<template>
    <div>
        <div class="container-fluid mt--7">
            <br><br><br>
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">

                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase" v-html="title"></h3>
                                    <br>
                                    <span class="text-danger" v-html="description"></span>
                                </div>
                                <div class="col-4 text-right">
                                    <router-link
                                        to="/"
                                        class="btn btn-danger"
                                    >
                                        <i class="fa fa-reply"></i>
                                        Back
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div v-if="! submitted">
                            <!-- this is school's profile template -->
                            <ProfileData
                                :id="application.id"
                                :data="application"
                                :transaction="application.transaction"
                                :loadApplication="loadApplication"
                                :displaySummary="displaySummary"
                                v-if="showProfileData && application && application.training_school && ! isLoadingBlade"
                            />

                            <!-- this is application summary template -->
                            <ApplicationSummary
                                :id="application.id"
                                :application="application"
                                :loadApplication="loadApplication"
                                :displayProfileData="displayProfileData"
                                v-if="showSummary && application && ! isLoadingBlade"
                            />

                            <div class="col-lg-12" v-if="isLoadingBlade">
                                <div class="d-flex justify-content-center">
                                    <img :src="loadingBladeUrl" />
                                </div>
                            </div>

                            <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
                                <base-alert :type="errorType">
                                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                                    <span class="alert-inner--text">
                                        <h2 class="text-white">{{errorMsg}}</h2>
                                    </span>
                                </base-alert>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ProfileData from '../../../Verification/Application/Advisory/ProfileData.vue';
    import ApplicationSummary from '../../../Verification/Application/Advisory/ApplicationSummary.vue';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'AdvisoryForm',
        components: {
            ProfileData,
            ApplicationSummary
        },
        data() {
            return {
                code: this.$route.params.code,
                id: this.$route.params.id,
                application: null,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isLoadingBlade: true,
                showProfileData: true,
                showSummary: false,
                title: null,
                description: null,
                departments: []
            }
        },
        computed: {
            ...mapGetters(['websiteUrl', 'locations', 'loadingBladeUrl']),
            submitted() {
                return this.hospital && (this.hospital.status == 'submitted' || this.hospital.status == 'approved'
                    || this.hospital.status == 'rejected');
            }
        },
        methods: {
            ...mapActions(['getApplication']),
            loadTitle() {// load title
                this.title = this.replaceString(this.$route.name, this.code);
                this.description = 'Kindly fill the form below with correct information...';
            },
            replaceString(value, code) {
                return value && code ? code+' '+ value.replace('-', ' ') : 'Application Form';
            },
            changeTitle(value, des, status) {// change title
                let description = des ? des : 'Kindly fill the form below with correct information...';
                if(status) {
                    this.title = value;
                    this.description = description;
                } else {
                    this.loadTitle();
                }
            },
            loadApplication() {
                this.isLoadingBlade = true;
                this.application = null;
                if(this.id) {
                    this.getApplication(this.id).then((res) => {
                        this.isLoadingBlade = false;
                        if(res.status) {
                            this.loadTitle();
                            this.application = res.application;
                            this.departments = res.departments;
                            if(! res.application) { return window.location.href = '/'; }
                            if(res.application && (res.application.status == 'approved') ) { return window.location.href = '/'; }
                        } else {
                            let msg = 'Payment has not been made, proceed to make payment'
                            swal.fire("Payment Failed!", msg, "warning");
                            setTimeout(function() { window.location.href = '/'+this.code+'-generate'; }, 3000);
                        }
                    }).
                    catch(() => {
                        this.showErrorStatus = true;
                        this.isLoadingBlade = false;
                        this.errorMsg = "Network Failure!, kindly reload the page...";
                        this.errorType = 'danger';
                    });
                } else {
                    let msg = 'An error occurred, try again...'
                    swal.fire("Error Ocurred!", msg, "warning");
                    setTimeout(function() { window.location.href = '/applications'; }, 3000);
                }
            },
            displayProfileData(value) {
                this.showProfileData = value;
                this.showSummary = ! value;
            },
            displaySummary(value) {
                this.showProfileData = ! value;
                this.showSummary = value;
            }
        },
        created() {
            this.loadApplication();
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>